import { render, staticRenderFns } from "./UpTeachingPlan.vue?vue&type=template&id=2412be6c&scoped=true&"
import script from "./UpTeachingPlan.vue?vue&type=script&lang=js&"
export * from "./UpTeachingPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412be6c",
  null
  
)

export default component.exports